export default "__VITE_ASSET__8351c41e__"